export interface Links {
  links: Record<string, string>;
}

const state = (): Links => ({
  links: {},
});

const getters = {
  GET_LINKS: (state: any) => {
    return state.links;
  },
};

const mutations = {
  SET_LINKS(state: any, newPropertyValue: Record<string, string>): void {
    state.links = Object.assign({}, state.links, newPropertyValue);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
